import Vue from 'vue';
import main from './main.vue';
import store from './store';
import vuetify from '../../plugins/vuetify';
import MyAxios from '../../views/@components/logics/MyAxios.vue'


Vue.config.productionTip = false;
Vue.mixin(MyAxios);


const components = vuetify.customComponents;
components.regist();

new Vue({
    store,
    vuetify,
    render: (h) => h(main),
}).$mount('#app');
